import _ from "lodash"
import defaultMessages from "../../../i18n/default.messages"

let messages = {
    messages: {
        'es-MX': {
            moduleTitle: 'Recursos de menú {menuName}',
            dlgEditSettingsTitle: "Nuevo recurso ",
            btnSave: 'ACEPTAR',
            btnCancel: 'CANCELAR',

            headerResource: "Recurso",
            headerType: "Tipo de recurso",
            headerAction: "Acciones",

            tblbutton: "Agregar recurso",

            lblContent: "Tipo de contenido",
            lblResources: "Recurso",

        },
        en: {
            moduleTitle: "{menuName}'s resource",


            dlgEditSettingsTitle: "New resource ",
            btnSave: 'ACCEPT',
            btnCancel: 'CANCEL',

            headerResource: "Resource",
            headerType: "Resource type",
            headerAction: "Actions",

            tblbutton: "Add resource",

            lblContent: "Type of content",
            lblResources: "Resource",
        }
    }
}

export default _.merge(messages, defaultMessages)